export default "__VITE_PUBLIC_ASSET__4530acaa__"